import { useTranslation } from 'react-i18next';
import { Button, Card, Typography } from 'antd';

import { Container } from '@/ui';
import { useScoringCategories } from '@/features/constructorScoringCategory/hooks';
import { useNavigate } from 'react-router';

export const ScoringCategoryList = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data, isLoading } = useScoringCategories();

  return (
    <>
      <Container $marginBottom={30}>
        <Typography.Title level={4}>{t('Scoring categories list')}</Typography.Title>
      </Container>

      {isLoading && <div>{t('Loading')}...</div>}

      {data?.map((category) => (
        <Card
          size='small'
          title={category.type}
          key={category.id}
          style={{ marginBottom: '10px' }}
          styles={{
            header: {
              fontWeight: 300,
              fontSize: '14px'
            }
          }}
        >
          {category.name && (
            <Typography.Title level={5}>
              {category.name} ({category.minPoints}-{category.maxPoints} points)
            </Typography.Title>
          )}
          {category.title && <Typography.Text level={5}>{category.title}</Typography.Text>}

          <Container $marginTop={12}>
            <Button
              onClick={() => navigate(`/constructorScoringCategory/${category.id}`)}
              type='primary'
            >
              {t('Edit')}
            </Button>
          </Container>
        </Card>
      ))}
    </>
  );
};
